import { FC, useCallback, useEffect, useState } from "react";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import Page from "../common/navigation/Page";
import BackButton from "../common/navigation/BackButton";
import Button from "../common/F7/Button";
import ButtonSmall from "../common/F7/ButtonSmall";
import ListBlock from "../common/F7/ListBlock";
import ListBlockItem from "../common/F7/ListBlockItem";
import FormFields from "../common/form/FieldsList";
import FormButtons from "../common/form/Buttons";
import F7 from "../../utils/F7";
import ContentTitle from "../common/F7/ContentTitle";
import { Field } from "../common/form/FieldHandler";
import Spinner from "../common/F7/Spinner";
import { useUpdateProject } from "../../hooks/database/usePouchUpdate";
import { useCurrentInventoryId, useCurrentDatabaseId } from "../../hooks/url";
import { useCurrentInventory } from "../../hooks/database/useCurrentInventory";
import { useCurrentProject } from "../../hooks/database/useCurrentProject";
import "../../index.scss";

const InventoryEditPage: FC = () => {
  const { inventoryId } = useCurrentInventoryId();
  const { data: inventory } = useCurrentInventory();
  const { data: project } = useCurrentProject();
  const { execute: updateProject } = useUpdateProject();
  const { databaseId } = useCurrentDatabaseId();

  const [form, setForm] = useState<Record<"name" | "cluster", Field>>({
    name: {
      label: "Inventory Name",
      type: "text",
      value: null,
    } as Field,
    cluster: {
      label: "Cluster Points",
      type: "checkbox",
      value: false,
    } as Field,
  });
  const [changeFields, setChangeFields] = useState(false);

  useEffect(() => {
    if (inventory) {
      setForm((f) =>
        _.merge({}, f, {
          name: { value: inventory.name },
          cluster: { value: inventory.cluster },
        }),
      );
    }
  }, [inventory]);
  const navigate = useNavigate();

  const handleSave = useCallback(async () => {
    const name = form.name.value as string;
    const cluster = form.cluster.value as boolean;

    if (!name || name.length < 1) {
      F7.alert("", "Inventory Name is required");
      return;
    } else if (name.length > 0 && name.charCodeAt(0) === 32) {
      F7.alert("", "Inventory Name can not start with a blankspace");
      return;
    }

    await updateProject(_.merge(project!, { inventories: { [inventoryId!]: { name, cluster } } }));
  }, [project, form.name, form.cluster, updateProject, inventoryId]);
  //const { projectId } = useParams();
  console.log(project?._id);
  console.log(inventoryId);
  console.log(databaseId);
  const handleCancel = useCallback(() => {
    const pid = project && project._id;
    navigate(`/d/${databaseId}/p/${pid}/edit`);
  }, [navigate, project, databaseId]);
  const handleFormChange = useCallback((field: string, value: Field["value"]) => {
    setForm((f) => _.merge({}, f, { [field]: { value } }));
  }, []);

  const handleDeleteFormClick = useCallback(
    async (formKey: string) => {
      const project_ = _.cloneDeep(project!);
      delete project_.inventories![inventoryId!].forms[formKey];
      await updateProject(project_);
    },
    [project, inventoryId, updateProject],
  );

  const handleDeleteStyleClick = useCallback(
    async (styleKey: string) => {
      const project_ = _.cloneDeep(project!);
      delete project_.inventories![inventoryId!].styles![styleKey];
      await updateProject(project_);
    },
    [inventoryId, project, updateProject],
  );

  const handleEditToggle = useCallback(() => {
    setChangeFields((current) => !current);
  }, []);

  /*const css = {
    removeIcon: {
      color: "red",
      fontSize: 28,
      paddingLeft: 10,
    },
  };*/

  if (!inventory) {
    return <Spinner />;
  }

  return (
    //<Page title="Edit Inventory" navbarLeft={<BackButton />} noToolbar>
    /*style={{
          float: "right",
          marginRight: 10,
          marginTop: -35,
        }}*/
    <Page title="Edit Inventory" navbarLeft={<BackButton onClick={handleCancel}>Close editor</BackButton>} noToolbar>
      <FormFields fields={form} onChange={handleFormChange} />

      <ContentTitle>Existing Templates</ContentTitle>

      <div className="buttonContainer">
        {Object.keys(inventory.forms).length ? (
          <ButtonSmall onClick={handleEditToggle}>{changeFields ? "Done" : "Change"}</ButtonSmall>
        ) : null}
      </div>

      <ListBlock>
        {Object.values(inventory.forms).map((form) => (
          <ListBlockItem
            key={form.key}
            media={
              changeFields ? (
                //<i className="fa fa-minus-circle" style={css.removeIcon} onClick={() => handleDeleteFormClick(form.key)} />
                <i className="fa fa-minus-circle removeIcon" onClick={() => handleDeleteFormClick(form.key)} />
              ) : null
            }
            title={form.name}
            to={`../form/${form.key}`}
          ></ListBlockItem>
        ))}
      </ListBlock>

      <Button to="../form/new">Add Template</Button>

      <ContentTitle>Styles</ContentTitle>
      <ListBlock>
        {Object.values(inventory.styles || {}).map((style) => (
          <ListBlockItem
            key={style.key}
            media={
              changeFields ? (
                <i className="fa fa-minus-circle removeIcon" onClick={() => handleDeleteStyleClick(style.key)} />
              ) : (
                //<div className="listblockitemcontainer" />
                <div
                  style={{
                    backgroundColor: style.color,
                    width: 25,
                    height: 25,
                    border: "solid 4px",
                    borderColor: style.borderColor,
                  }}
                />
              )
            }
            title={style.formFieldValue}
            after={style.name}
            to={`../style/${style.key}`}
          ></ListBlockItem>
        ))}
      </ListBlock>

      <Button to="../style/new">Add Style</Button>

      <hr />

      <FormButtons onSave={handleSave} />
    </Page>
  );
};

export default InventoryEditPage;
